import React, { useState } from 'react';
import { FaHome, FaPills, FaClipboard, FaSignOutAlt, FaBars, FaTimes, FaBox, FaTruck, FaClipboardList, FaChartBar, FaGift, FaShoppingCart, FaFacebookMessenger } from 'react-icons/fa';
import './Sidebar.css';
import logo from '../../assets/logo/fulllogo.png';

const Sidebar = ({ role, onLinkClick }) => {
  const [activeLink, setActiveLink] = useState('');
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    onLinkClick(link);
  };

  const handleMobileSidebarToggle = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  const handleBackdropClick = () => {
    setIsMobileSidebarOpen(false);
  };

  const getSidebarLinks = () => {
    switch (role) {
      case 'pharmacist':
        return [
          { id: 'dashboard', icon: <FaHome />, label: 'Dashboard' },
          { id: 'inventory', icon: <FaBox />, label: 'Inventory' },
          { id: 'wards', icon: <FaGift />, label: 'Departments' },
          { id: 'orders', icon: <FaShoppingCart />, label: 'Orders' },
          { id: 'vendors', icon: <FaBox />, label: 'Distributors' },
          { id: 'notifications', icon: <FaGift />, label: 'Notifications' },
          { id: 'analytics', icon: <FaChartBar />, label: 'Analytics' },
          { id: 'drugs', icon: <FaPills />, label: 'Drugs' },
          { id: 'donations', icon: <FaGift />, label: 'Support' },
        ];
      case 'distributor':
        return [
          { id: 'dashboard', icon: <FaHome />, label: 'Dashboard' },
          { id: 'inventory', icon: <FaBox />, label: 'Inventory' },
          { id: 'orders', icon: <FaTruck />, label: 'Orders' },
          { id: 'notifications', icon: <FaGift />, label: 'Notifications' },
          { id: 'analytics', icon: <FaClipboardList />, label: 'Analytics' },
          { id: 'marketplace', icon: <FaClipboardList />, label: 'Marketplace' },
          {id: 'orderreq', icon:<FaFacebookMessenger/>, label:'Order Requests'},
        ];
      case 'ward':
        return [
          { id: 'inventory', icon: <FaBox />, label: 'Inventory' },
          { id: 'drugConsumption', icon: <FaBox />, label: 'Drug Consumptions' },
          { id: 'indentReq', icon: <FaBox />, label: 'Indents' },
          { id: 'SindentReq', icon: <FaBox />, label: 'Special Indents' },
          { id: 'notifications', icon: <FaGift />, label: 'Notifications' },
        ];
      default:
        return [];
    }
  };

  const links = getSidebarLinks();

  return (
    <>
      {isMobileSidebarOpen && (
        <div className="backdrop" onClick={handleBackdropClick}></div>
      )}

      <div className={`sidebar ${isMobileSidebarOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="Company Logo" className="sidebar-logo" draggable="false" />
        </div>
        <div className="sidebar-links">
          {links.map(link => (
            <div
              key={link.id}
              className={`sidebar-link ${activeLink === link.id ? 'active' : ''}`}
              onClick={() => handleLinkClick(link.id)}
            >
              {link.icon}
              <span>{link.label}</span>
            </div>
          ))}
        </div>
        <div className="sidebar-footer">
          <button className="sidebar-btn logout-btn">
            <FaSignOutAlt className="link-icon" />
            <span>Logout</span>
          </button>
          <button className="sidebar-btn report-btn">
            <FaClipboard className="link-icon" />
            <span>Report</span>
          </button>
        </div>
      </div>

      <div className={`mobile-sidebar ${isMobileSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <img src={logo} alt="Company Logo" className="sidebar-logo" />
        </div>
        <div className="sidebar-links">
          {links.map(link => (
            <div
              key={link.id}
              className={`sidebar-link ${activeLink === link.id ? 'active' : ''}`}
              onClick={() => handleLinkClick(link.id)}
            >
              {link.icon}
              <span>{link.label}</span>
            </div>
          ))}
        </div>
        <div className="sidebar-footer">
          <button className="sidebar-btn logout-btn">
            <FaSignOutAlt className="link-icon" />
            <span>Logout</span>
          </button>
          <button className="sidebar-btn report-btn">
            <FaClipboard className="link-icon" />
            <span>Report</span>
          </button>
        </div>
      </div>

      <div className="burger-icon" onClick={handleMobileSidebarToggle}>
        {isMobileSidebarOpen ? <FaTimes /> : <FaBars />}
      </div>
    </>
  );
};

export default Sidebar;
